import ValidationMessage, { ValidationMessageProps } from './ValidationMessage';

export type { ValidationMessageProps };
export default ValidationMessage;
